import request from '../request'
import handler from '@/utils/responseHandler'
import localStorage from '@/utils/localStorage'

/*
  登录相关
  4101    获取验证码
  41021   手机号登录
  41012   通过refreshcode获取authcode
  41013   更新refreshcode过期时间
  41216   高铁授权换取航班授权
  331623  通过手机号查authcode
*/

export default {
  '4101': ({
      phone
    }) =>
    request.ticket({
      url: '/v3/user/login',
      data: {
        pid: 4101,
        type: 'gtgj',
        phone
      },
      sidFields: ['uid', 'pid', 'phone']
    }, false),
  '41021': ({
      phone,
      code
    }) =>
    request.ticket({
      url: '/gateway/user/loginverify',
      data: {
        pid: 41021,
        system: 'gtgj',
        phone,
        code
      },
      sidFields: ['uid', 'pid', 'phone', 'systemtime']
    }, false),
  '41012': (refreshcode) =>
    request.ticket({
      url: '/gateway/user/authtemp',
      method: 'POST',
      data: {
        pid: 41012,
        refreshcode
      },
      sidFields: ['uid', 'pid', 'refreshcode', 'systemtime']
    }, false),
  '41013': (refreshcode) =>
    request.ticket({
      url: '/gateway/user/delayrefresh',
      data: {
        pid: 41013,
        refreshcode
      },
      sidFields: ['uid', 'pid', 'refreshcode', 'systemtime']
    }, false),
  '41216': (code) =>
    request.ticket({
      url: '/gateway/user/auth',
      data: {
        pid: 41216,
        system: 'gtgj',
        code
      },
      sidFields: ['uid', 'pid', 'code', 'systemtime']
    }, false),
  '331623': ({
    passengerMobile,
    maycurSignValue,
    timestamp
  }) => {
    let ptid = localStorage.get('ptid')
    return request.ticket({
      url: '/gateway/gtgj/daigou',
      data: {
        pid: 331623,
        ptid,
        passengerMobile,
        maycurSignValue,
        timestamp
      },
      sidFields: ['uid', 'pid']
    }, false).then(handler.resBdData)
  }
}



// WEBPACK FOOTER //
// ./src/api/login.js